import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import FarmLoader, { useGlobalOverlayOpen } from './FarmLoader'

type LoadingProps = {
  open?: boolean
  label?: string
  // Renderiza dentro da área da página, sem overlay: sidebar, topo e indicador de
  // sync continuam acessíveis durante carregamentos longos.
  inline?: boolean
  // É o overlay global (LoadingOverlay, ligado por state.screen.loading). Só
  // ele passa true: é o único que nunca cede a vez para outro loader.
  isGlobalOverlay?: boolean
}

const Loading = ({
  open = false,
  label,
  inline = false,
  isGlobalOverlay = false,
}: LoadingProps) => {
  // Um overlay local (Login, DG, ImportData...) aberto junto com o global
  // empilhava dois cartões e escurecia o fundo duas vezes: cede a vez. O
  // loader inline cuida de si mesmo dentro do FarmLoader.
  const yieldToGlobal = useGlobalOverlayOpen() && !inline && !isGlobalOverlay

  if (!open || yieldToGlobal) return null

  const labelProps = label ? { label } : {}

  if (inline) {
    return (
      <div
        className='farmLoader-inline'
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: 200,
        }}
      >
        <FarmLoader {...labelProps} labelColor='#5C5C5C' />
      </div>
    )
  }

  return (
    <div
      style={{
        zIndex: 100000,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Backdrop
        open
        transitionDuration={0}
        className='farmLoader-backdrop'
        sx={{ backgroundColor: 'rgba(26, 26, 26, 0.45)', px: 2 }}
      >
        <div className='farmLoader-card'>
          <FarmLoader
            {...labelProps}
            labelColor='#1A1A1A'
            isGlobalOverlay={isGlobalOverlay}
          />
        </div>
      </Backdrop>
    </div>
  )
}

export default Loading
